
/**
 * @name InternalTickets.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\InternalTickets.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
import Swal from 'sweetalert2';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, toggleNotificationState = null, getCourtesyIsUsed = null, getInternalTicketCategoryType = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        toggleNotificationState = utils.toggleNotificationState;
        getCourtesyIsUsed = utils.getCourtesyIsUsed;
        getInternalTicketCategoryType = utils.getInternalTicketCategoryType;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'contratos/cancelar-contrato-em-andamento')
            return;

        new ContractsAndPatientTransfer(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class ContractsAndPatientTransfer
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.onloadList = onloadList;
        this.planList = [];
        this.init();
    }

    init() {
        let self = this;
        this.customerContracts = null;
        this.customerData = null;

        // Resgata lista de planos
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/plans',
            successCallback: function(res) {
                if (!res.error) {
                    self.businessPlans = res.data;

                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i = 0; i < res.data.length; i++) {
                        let plan = res.data[i];
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    }
                    $('.js-contracts-plan-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });

        $(document).on('change', '#contract_cancel_origin_branch', this.onChangeBranch.bind(this));
        $(document).on('submit','.js-contracts-registrations-filter-form', this.onSubmit.bind(this));
        $(document).on('change', '#contract_cancel_contract_number', this.onSelectContract.bind(this));

        $(document).on('click', '.js-contract-cancel-clear-fields', function() {
            $('#contract_cancel_patient').val(null).trigger('change');
            $("#cancel_contract_customer_id").val('');
            $("#contract_cancel_contract_number").prop('disabled', true);
            $("#contract_cancel_contract_number").html('');
            $('.js-contract-active-cancel-patient-cpf').val('');
            $('.js-contract-active-cancel-patient-plan').val('');
            $('#contract_cancel_sessions_attedend').html('0');
            $('#contract_cancel_sessions_scheduled').html('0');
            $('#contract_cancel_sessions_open').html('0');
            $("#contract_cancel_reason").val('');
            $("#contract_cancel_submit").prop('disabled', true);
        });

        $('#contract_cancel_patient').select2({
            placeholder: "Busque por nome ou código do contrato",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function(params) {
                    var query = {
                        search: params.term,
                        branchId: self.selectedBranch || -1,
                        page: params.page || 1,
                        allContracts: true
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function(k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });
        
        $('#contract_cancel_patient').on('select2:select', function(e) {
            $("#cancel_contract_customer_id").val(e.params.data.info.ID);
            self.customerData = e.params.data.info;
            self.customerContracts = e.params.data.info.CONTRATOS;
            self.renderPatientActiveContracts(self.customerContracts);
            $('.js-contract-active-cancel-patient-cpf').val(e.params.data.info.CPF || e.params.data.info.PASSAPORTE);
        });
    }

    onChangeBranch(e) {
        this.selectedBranch = e.target.value;
        $('#contract_cancel_patient').val(null).trigger('change');

        if (this.selectedBranch == '') {
            $('#contract_cancel_patient').prop('disabled', true);
            $('#contract_cancel_patient').val(null).trigger('change');
            $("#cancel_contract_customer_id").val('');
            $("#contract_cancel_contract_number").prop('disabled', true);
            $("#contract_cancel_contract_number").html('');
            $('.js-contract-active-cancel-patient-cpf').val('');
            $('.js-contract-active-cancel-patient-plan').val('');
            $('#contract_cancel_sessions_attedend').html('0');
            $('#contract_cancel_sessions_scheduled').html('0');
            $('#contract_cancel_sessions_open').html('0');
            $("#contract_cancel_reason").val('');
            $("#contract_cancel_reason").prop('disabled', true);
            $("#contract_cancel_submit").prop('disabled', true);
            return;
        }

        $('#contract_cancel_patient').val(null).trigger('change');
        $("#cancel_contract_customer_id").val('');
        $("#contract_cancel_contract_number").prop('disabled', true);
        $("#contract_cancel_contract_number").html('');
        $('.js-contract-active-cancel-patient-cpf').val('');
        $('.js-contract-active-cancel-patient-plan').val('');
        $('#contract_cancel_sessions_attedend').html('0');
        $('#contract_cancel_sessions_scheduled').html('0');
        $('#contract_cancel_sessions_open').html('0');
        $("#contract_cancel_reason").val('');
        $("#contract_cancel_reason").prop('disabled', true);
        $('#contract_cancel_patient').prop('disabled', false);
        $("#contract_cancel_submit").prop('disabled', true);
    }

    onSubmit(e) {
        e.preventDefault();
        Swal.fire({
            title: 'Cancelar contrato',
            text: 'Tem certeza que deseja cancelar o contrato?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, cancelar contrato',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                let contractId = $('#contract_cancel_contract_number').val();
                let reason = $('#contract_cancel_reason').val();
                let customerId = $("#cancel_contract_customer_id").val();

                $('.js-contracts-registrations-filter-form').find('input, select, button, textarea').prop('disabled', true);

                apiCall({
                    method: 'POST',
                    endpoint: 'api/v1/patient/contract/cancel',
                    data: {
                        contractId: contractId,
                        reason: reason,
                        customerId: customerId
                    },
                    successCallback: function(res) {
                        $('.js-contracts-registrations-filter-form').find('input, select, button, textarea').prop('disabled', false);
                        if (!res.error) {
                            Swal.fire({
                                title: 'Sucesso',
                                text: 'Contrato cancelado com sucesso',
                                icon: 'success',
                                confirmButtonColor: '#3085d6'
                            });
                            $('.js-contract-active-cancel-patient-cpf').val('');
                            $('.js-contract-active-cancel-patient-plan').val('');
                            $('#contract_cancel_sessions_attedend').html('0');
                            $('#contract_cancel_sessions_scheduled').html('0');
                            $('#contract_cancel_sessions_open').html('0');
                            $("#contract_cancel_reason").val('');
                            $("#contract_cancel_reason").prop('disabled', true);
                            $("#contract_cancel_submit").prop('disabled', true);
                            $("#contract_cancel_patient").prop('disabled', true);
                            $('#contract_cancel_patient').val(null).trigger('change');
                            $("#cancel_contract_customer_id").val('');
                            $("#contract_cancel_contract_number").prop('disabled', true);
                            $("#contract_cancel_contract_number").html('');
                            $('.js-contracts-registrations-filter-form').trigger('reset');
                        } else {
                            Swal.fire({
                                title: 'Erro',
                                text: res.message,
                                icon: 'error',
                                confirmButtonColor: '#3085d6'
                            });
                        }
                    },
                    errorCallback: function(err) {
                        $('.js-contracts-registrations-filter-form').find('input, select, button, textarea').prop('disabled', false);
                        
                        Swal.fire({
                            title: 'Erro',
                            text: 'Ocorreu um erro ao cancelar o contrato',
                            icon: 'error',
                            confirmButtonColor: '#3085d6'
                        });
                    }
                });
            }
        });
    }

    onSelectContract(e) {
        let contractId = e.target.value;
        let contract = this.customerContracts[contractId];

        if (!contract)
            return;

        let plan = this.businessPlans.find(p => p.ID == contract.PLANO);

        let attendedSessions = 0,
            scheduledSessions = 0,
            openSessions = 0;
        for(let i = 0; i < contract.sessoes.length; ++i) {
            let parcela = contract.sessoes[i];
            //console.log('parcela', parcela);
            if (parcela) {
                if (parcela.STATUS == 'A') {
                    attendedSessions++;
                }
                if (parcela.AGENDA_ID != null && parcela.STATUS == null) {
                    scheduledSessions++;
                }
                if (parcela.STATUS == null) {
                    openSessions++;
                }
            }
        }

        /*console.log('attendedSessions', attendedSessions);
        console.log('scheduledSessions', scheduledSessions);
        console.log('openSessions', openSessions);*/

        $('.js-contract-active-cancel-patient-plan').val(plan.DESCRICAO);
        $('#contract_cancel_sessions_attedend').html(attendedSessions);
        $('#contract_cancel_sessions_scheduled').html(scheduledSessions);
        $('#contract_cancel_sessions_open').html(openSessions);

        $("#contract_cancel_reason").prop('disabled', false);
        $("#contract_cancel_submit").prop('disabled', false);
    }

    renderPatientActiveContracts(customerContracts) {
        $("#contract_cancel_contract_number").prop('disabled', false);
        //console.log('customerContracts', customerContracts);
        let contracts = Object.values(customerContracts);

        let options = contracts.map(contract => {
            if (contract.STATUS != 'A')
                return '';
            return `<option value="${contract.CONTRATO_ID}">N° ${contract.CONTRATO_ID}</option>`;
        });

        $("#contract_cancel_contract_number").html(options.join(''));
        $("#contract_cancel_contract_number").trigger('change');
    }

    clearFormState() {

    }
}